export default "__VITE_ASSET__D$DVmkt7__"